import classNames from 'classnames';

import { Icon, Typography } from '@sravni/react-design-system';
import { useIsMobile } from '@sravni/react-utils';

import { adengiBannerImage, ADengiLogoSvg, adgeniMobileImage } from '@src/assets/adengiBanner';
import { OptimizedPicture } from '@src/components/ui/OptimizedPicture';
import { open } from '@src/helpers/navigationHelper';
import { PIXEL_DISPLAY_WRAPPER_STYLES } from 'widgets/LightweightCard/ui/LightweightCard.config';

import { SponsoredBadge } from '../SponsoredBadge/SponsoredBadge';
import { SponsoredMenu } from '../SponsoredMenu/SponsoredMenu';

import { ADENGI_COMPANY_NAME, ADENGI_PIXEL_VIEW, ADENGI_URL } from './ADengiBanner.config';
import styles from './ADengiBanner.module.scss';

export function ADengiBanner() {
  const isMobile = useIsMobile();

  const handleClick = () => {
    open({ href: ADENGI_URL, features: 'noopener', target: '_blank' });
  };

  const sizes = isMobile ? { width: 145, height: 116 } : { width: 440, height: 320 };
  return (
    <>
      <div className={classNames(styles.advertising, 'desktop:hidden')}>
        <SponsoredMenu company={ADENGI_COMPANY_NAME} token="2W5zFGg59GC" />
        <SponsoredBadge onClick={handleClick} />
      </div>
      <div className={styles.container}>
        <div onClick={handleClick}>
          {/* нужно именно перемонтирование компонентов иначе будет шакалится фотка)) при смене разрешения */}
          {isMobile ? (
            <OptimizedPicture img={adgeniMobileImage} alt="Банер" {...sizes} />
          ) : (
            <OptimizedPicture img={adengiBannerImage} alt="Банер" {...sizes} />
          )}
        </div>
        {/* такой костыль потому что наш пиксель обогащает данными, в данном случае обогащать необходимости нет */}
        <img alt="" style={PIXEL_DISPLAY_WRAPPER_STYLES} src={ADENGI_PIXEL_VIEW} />
        <div className={classNames(styles.advertising, 'mobile:hidden')}>
          <SponsoredMenu company={ADENGI_COMPANY_NAME} token="2W5zFGg59GC" />
          <SponsoredBadge onClick={handleClick} />
        </div>
      </div>
    </>
  );
}
